import { useEffect, useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material'

function TabElement(props = {panelId: '', children: undefined, value: undefined, index: undefined }) {
  const { panelId = 'p', children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${panelId}-tabpanel-${index}`}
      aria-labelledby={`${panelId}-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabElement.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function TabPanel(props = {panelId: '', tabs: [{ key: '', label: '', title: '', el: undefined }], defaultTab: 0, onTabChange: undefined, tabStyle: undefined}) {
  const { panelId = 'p', tabs = [], defaultTab = 0, tabStyle } = props
  const [currentTab, setCurrentTab] = useState(defaultTab);

  function a11yProps(index) {
    return {
      id: `${panelId}-tab-${index}`,
      'aria-controls': `${panelId}-tabpanel-${index}`,
    };
  }

  const onTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    if (props.onTabChange) props.onTabChange(newValue)
  };

  useEffect(() => {
    setCurrentTab(defaultTab)
  }, [defaultTab])

  return (
    <Box sx={{ flexGrow: 1, width: props.fullWidth ? '100%' : undefined }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

        <Tabs value={currentTab} onChange={onTabChange} style={tabStyle}>
          {tabs.map((tab, i) => {
            const hasTitle = !!tab.title
            const t = <Tab label={tab.label} key={hasTitle ? undefined : tab.key} {...a11yProps(i)} disableRipple style={tabStyle} />
            const conditionalT = hasTitle ? <Tooltip title={tab.title} key={tab.key} arrow placement='bottom' >{t}</Tooltip> : t
            return conditionalT
          })}
        </Tabs>
      </Box>

      {tabs.map((tab, i) => <TabElement value={currentTab} index={i} key={`${tab.key}_${i}`}>
        {tab.el}
      </TabElement>)}

    </Box>
  )

}